import { Chat } from "@acoladgroup/tempo-messaging-library";
import Button from "components/buttons/Button";
import { useTranslation } from "react-i18next";
import { TaskBase } from "../../taskBase.typing";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import { AlertTriangle } from "lucide-react";
import { useCreateTempoChatMutation, useGetTempoChatQuery, useTempoChatUnreadCounts } from "query/tempo-chat.query";

export const ContactCustomer = ({ task }: { task: TaskBase }) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const fetchTempoChat = useGetTempoChatQuery();
  const createTempoChat = useCreateTempoChatMutation();

  const { getUnreadCountPerChat } = useTempoChatUnreadCounts();

  const openChat = async (taskId: string) => {
    if (!task.chatEnabled) {
      toast.custom(
        <div className="flex max-w-xl items-center gap-2 rounded-lg border border-amber-400 bg-amber-100 p-3">
          <div>
            <AlertTriangle className="size-6 text-amber-600" />
          </div>

          <div className="font-medium text-amber-900">This feature is not currently accessible for this project</div>
        </div>
      );
      return;
    }
    let chatData: Chat;
    if (task.tempoChatId) {
      chatData = await fetchTempoChat(task.tempoChatId);
    } else {
      chatData = await createTempoChat.mutateAsync(taskId);
    }
    const newParams = new URLSearchParams(searchParams);
    newParams.set("chat", chatData.id.toString());
    setSearchParams(newParams);
  };

  return (
    <div className="relative inline-block">
      <Button
        color="ternary"
        dataTestId={`card-task-${task.id}-contact-customer-button`}
        label={t("task-base.contactCustomer")}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          openChat(task.id);
        }}
      />
      {getUnreadCountPerChat(task.tempoChatId) > 0 && (
        <span className="absolute -right-1 -top-1 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-red-500 px-2 py-1 text-xs font-bold leading-none text-white">
          {getUnreadCountPerChat(task.tempoChatId) > 9 ? "9+" : getUnreadCountPerChat(task.tempoChatId)}
        </span>
      )}
    </div>
  );
};
